import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IRestaurantsContext, RestaurantsContext } from '../../../../restaurantsState/restaurantsContext';
import Item from './components/Item';
import classNames from 'classnames';
import style from './ActiveRestaurantsList.module.scss';

export const ActiveRestaurantsList: React.FC = () => {
	const { restaurants } = useContext<IRestaurantsContext>(RestaurantsContext);

	const addressHeadingClasses = classNames(style.address, style.heading);
	const customerHeadingClasses = classNames(style.customer, style.heading);
	const cityHeadingClasses = classNames(style.city, style.heading);
	const countryHeadingClasses = classNames(style.country, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="ActiveRestaurantsList">
			<div className={style.tableHeaders}>
				<div className={addressHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="nameLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
				<div className={customerHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="customerLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
				<div className={cityHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="cityLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
				<div className={countryHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="countryLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
				<div className={actionHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="actionLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
			</div>
			{restaurants.restaurants.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};
